import { useRef, useEffect, useState } from "react";
import ActionButton from "./ui/ActionButton";

const steps = [
  {
    number: "1",
    color: "bg-primary/15 text-primary",
    title: "Busca",
    description: "Ingresa tu zona y elige el servicio que necesitas. Filtra por disponibilidad, precio y tipo de mascota.",
    image: "/lovable-uploads/c8bc2c1d-16da-49e6-a878-3d55adacffa1.webp"
  },
  {
    number: "2",
    color: "bg-secondary/20 text-secondary",
    title: "Conecta",
    description: "Revisa perfiles verificados y reseñas reales. Chatea con el cuidador antes de confirmar.",
    image: "/lovable-uploads/a15e0c9c-8d6b-464b-9960-28966d6951d3.webp"
  },
  {
    number: "3",
    color: "bg-accent/20 text-accent-foreground",
    title: "Reserva",
    description: "Paga de forma segura dentro de la plataforma. Recibe fotos y actualizaciones durante el servicio.",
    image: "/lovable-uploads/45626103-6893-4bae-96d4-96b6b983aaaf.webp"
  }
];

const HowItWorks = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="como-funciona"
      className="section-padding !pt-10 md:!pt-24"
      style={{
        background: `
          radial-gradient(ellipse at 50% 50%, #ffffff 0%, transparent 60%),
          radial-gradient(ellipse at 0% 0%, #fef9e7 0%, transparent 50%),
          radial-gradient(ellipse at 100% 100%, #fef9e7 0%, transparent 50%),
          radial-gradient(ellipse at 100% 0%, #fef9e7 0%, transparent 40%),
          radial-gradient(ellipse at 0% 100%, #fef9e7 0%, transparent 40%),
          #fef9e7
        `
      }}
    >
      <div className={`container-custom mx-auto transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl font-fredoka font-bold text-foreground mb-3 md:text-6xl">
            Así de fácil funciona Compaws
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto md:text-2xl">
            Reserva tu servicio en menos de 2 minutos.
          </p>
        </div>

        {/* Steps */}
        <div className="flex flex-col md:grid md:grid-cols-3 gap-8 md:gap-12 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center group">
              {/* Step Number Badge - slightly larger */}
              <div className={`w-16 h-16 min-w-[64px] min-h-[64px] ${step.color} font-fredoka font-bold text-3xl rounded-full flex items-center justify-center mx-auto mb-3 shadow-md border-2 border-current/10`}>
                {step.number}
              </div>

              {/* Image - 200px height */}
              <div className="mb-6 flex justify-center">
                <img
                  src={step.image}
                  alt={step.title}
                  width={200}
                  height={200}
                  loading="lazy"
                  className="h-[200px] w-auto object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <h3 className="font-fredoka font-semibold text-foreground mb-3 text-4xl">
                {step.title}
              </h3>
              <p className="font-poppins text-muted-foreground max-w-xs mx-auto text-lg" style={{ lineHeight: 1.3 }}>
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <ActionButton to="/registro" size="xl">
            Comenzar Ahora
          </ActionButton>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
